// extracted by mini-css-extract-plugin
export default {"section-title":"section-title_i65cB"};